import { useTranslation } from 'react-i18next';
import Button from '~/components/buttons/NewButton';
import Modal from '~/components/modals/Modal/Modal';
import ModalActions from '~/components/modals/Modal/ModalActions';
import ModalContent from '~/components/modals/Modal/ModalContent';
import ModalTitle from '~/components/modals/Modal/ModalTitle';
import Text from '~/components/typographies/Text';
import useDataTestId from '~/hooks/useDataTestId';
import { ModalProps } from '~/modals/Modal';

interface ConfirmDialogProps extends ModalProps {
  closeModal: (props?: { action: 'CONFIRM' } | { action: 'CLOSE' }) => void;
  action?: 'confirm' | 'destructive';
  title: string;
  text: string;
  confirmLabel?: string;
  dataTestId?: string;
  textClassName?: string;
}

const ConfirmDialog = ({
  action,
  title,
  text,
  confirmLabel,
  closeModal,
  dataTestId,
  textClassName,
}: ConfirmDialogProps) => {
  const { t } = useTranslation();
  const dt = useDataTestId(dataTestId);

  return (
    <Modal data-testid={dt()} maxWidth={600} isOpen fullWidth>
      <ModalTitle data-testid={dt('title')} onCloseClick={closeModal}>
        {title}
      </ModalTitle>
      <ModalContent data-testid={dt('content')}>
        <Text variant="body1" weight="regular" className={textClassName}>
          {text}
        </Text>
      </ModalContent>
      <ModalActions>
        <Button variant="outlined" data-testid={dt('cancelButton')} onClick={() => closeModal()}>
          {t('CANCEL')}
        </Button>
        <Button action={action} data-testid={dt('confirmButton')} onClick={() => closeModal({ action: 'CONFIRM' })}>
          {confirmLabel ?? t('CONFIRM')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
export default ConfirmDialog;
